<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchEquipment } from '@/api/games/equipment';

export default {
    name: "equipment-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchEquipment,
        }
    }
}
</script>
